import { useQuery } from '@tanstack/react-query';
import request, { gql } from 'graphql-request';

import { GraphQLEndpoint } from './endpoint';
import type { Product } from './types/graphql';

export const query = gql`
  query Products(
    $productType: String
    $env: String
    $contentFilter: JSONObject
  ) {
    content(env: $env) {
      listProducts(productType: $productType, contentFilter: $contentFilter) {
        id
        productKey
        title
        handle
        product_type
        colorMsgKey
        styleMsgKey
        titleMsgKey
        selectedTraits {
          name
          value
        }
        inStock
        isRing
        seoParams {
          title
          description
        }
        options {
          name
          value
        }
        imageAssets {
          alias
          src
        }
        images {
          originalSrc
          thumbnailSrc
          alt
        }
        lineItemImage {
          originalSrc
          alt
        }
        variants {
          sku
          skuCode
          id: variantId
          variantId
          productId
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
`;

export const PRODUCTS_ALL_KEY = 'All';

function withQueryKey(vars: {
  productType: string | null;
  contentFilter: Record<string, unknown>;
}) {
  return {
    key: [
      'useProductsData',
      vars.productType || PRODUCTS_ALL_KEY,
      vars.contentFilter,
    ],
    fetch: async () => {
      const data: any = await request(GraphQLEndpoint, query, {
        productType: vars.productType,
        contentFilter: vars.contentFilter,
      });
      return data.content.listProducts as Product[];
    },
  };
}

export function useProducts({
  productType = null,
  contentFilter = {},
}: {
  productType?: string | null;
  contentFilter?: Record<string, any>;
}) {
  const { key, fetch } = withQueryKey({
    productType,
    contentFilter,
  });

  return useQuery({
    queryKey: key,
    queryFn: fetch,
  });
}
